import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { Helmet } from "react-helmet-async";

export default withStyles({}, { name: "DocumentTitle" })(
  ({ favIcon, googleFonts: fonts, ...props }) => (
    <Helmet {...props}>
      {favIcon && <link rel="shortcut icon" href={favIcon} />}
      {fonts && (
        <link
          href={
            "https://fonts.googleapis.com/css?family=" + fonts + "&display=swap"
          }
          rel="stylesheet"
        />
      )}
    </Helmet>
  )
);
